import { ClubBasic } from '@/components/HomeComponents/TroneiosDosClubPadelMaster/TroneiosDosClubPadelMaster';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface ClubsState {
  clubs: ClubBasic[];
  status: 'loading' | 'success' | 'error';
}

const initialState: ClubsState = {
  clubs: [],
  status: 'loading',
};

export const clubsSlice = createSlice({
  name: 'clubs',
  initialState,
  reducers: {
    setClubs: (state, action: PayloadAction<ClubBasic[]>) => {
      return {
        ...state,
        clubs: action.payload,
        status: 'success',
      };
    },
  },
});

export const { setClubs } = clubsSlice.actions;

export default clubsSlice.reducer;
